import React, { createContext, useContext } from 'react';

const translations = {
  fr: {
    auth: {
      name: 'Full Name',
      email: 'Email Address',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      loading: 'Loading...',
      register: {
        title: 'Create Account',
        subtitle: 'Join Snap Chart AI Today',
        button: 'Sign Up',
        alreadyHaveAccount: 'Already have an account?',
        loginLink: 'Sign In'
      },
      login: {
        title: 'Sign In',
        subtitle: 'Access your account',
        button: 'Sign In',
        noAccount: 'No account?',
        registerLink: 'Sign Up',
        forgotPassword: 'Forgot password?'
      },
      forgotPassword: {
        title: 'Forgot Password',
        subtitle: 'Enter your email to receive a reset link',
        successTitle: 'Email Sent!',
        successMessage: 'Check your inbox for reset instructions.',
        checkEmail: 'A password reset link has been sent to your email.',
        backToLogin: 'Back to Login',
        sendLink: 'Send Reset Link',
        sending: 'Sending...'
      },
      error: {
        passwordsDoNotMatch: 'Passwords do not match',
        passwordTooWeak: 'Password is too weak',
        registrationFailed: 'Registration failed',
        loginFailed: 'Login failed',
        emptyEmail: 'Please enter your email address',
        emptyFields: 'Please fill in all fields',
        resetPasswordFailed: 'Failed to send reset email'
      }
    },
    trading: {
      title: 'Snap Chart AI - Professional Trading Intelligence',
      sessions: {
        title: 'Sessions',
        london: 'London',
        ny: 'New York',
        tokyo: 'Tokyo',
        sydney: 'Sydney'
      },
      voice: {
        startListening: 'Start Listening',
        stopListening: 'Stop Listening',
        stopSpeaking: 'Stop Speaking',
        replay: 'Replay',
        status: {
          listening: 'Listening...',
          speaking: 'Speaking...',
          idle: 'Idle'
        }
      }
    },
    promptEditor: {
      title: 'Prompt Editor',
      market: 'Market: {market}',
      placeholder: 'Enter your custom prompt...',
      variablesTitle: 'Available Variables:',
      variablesDesc: 'Use these variables in your prompt:',
      save: 'Save',
      reset: 'Reset'
    }
  }
};

const TranslationContext = createContext();

export const TranslationProvider = ({ children }) => {
  const t = (key, params = {}) => {
    const keys = key.split('.');
    let value = translations.fr;
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    if (typeof value === 'string' && params) {
      return value.replace(/\{(\w+)\}/g, (match, param) => params[param] || match);
    }
    
    return value || key;
  };

  return (
    <TranslationContext.Provider value={{ t }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
};